import React, { useState } from "react"
import { Button, Modal, Table, Tag } from "antd"
import { ExclamationCircleOutlined } from "@ant-design/icons"

export const ProjectProcess = ({ rowData, mainProps }) => {
  const [open, setOpen] = useState(false)

  const columns = [
    {
      title: "توضیحات کارشناس",
      dataIndex: "description",
      key: "description",
      align: "center",
      render: (_, record) => (
        <Button
          onClick={() => alert(record.description || "نوشته نشده")}
          type="primary"
        >
          نظر کارشناس
        </Button>
      ),
    },
    {
      title: "نام و نام خانوادگی",
      dataIndex: "engName",
      key: "engName",
      align: "center",
    },
    {
      title: "شماره موبایل",
      dataIndex: "cellPhone",
      key: "cellPhone",
      align: "center",
    },
    {
      title: "تاریخ تخصیص",
      dataIndex: "solarDateDeliverEngineer",
      key: "solarDateDeliverEngineer",
      align: "center",
    },
    {
      title: "تاریخ انجام",
      dataIndex: "solarDateDeliverOffice",
      key: "solarDateDeliverOffice",
      align: "center",
    },
    {
      title: "مرحله پرونده",
      dataIndex: "projectLevelName",
      key: "projectLevelName",
      align: "center",
    },
    {
      title: "وضعیت",
      key: "inspectionStatusName",
      render: row => (
        <Tag
          color={
            row.defect || row.inspectionStatusEnum === 2
              ? "red"
              : row.inspectionStatusEnum === 3 || row.inspectionStatusEnum === 2
              ? "red"
              : "green"
          }
        >
          {row.defect
            ? row.inspectionStatusName + "بانقص"
            : row.inspectionStatusName}
        </Tag>
      ),
      align: "center",
    },
    {
      title: "نقص دارد",
      dataIndex: "defect",
      key: "defect",
      align: "center",
      render: defect => (
        <Tag color={defect ? "red" : "green"}>{defect ? "بله" : "خیر"}</Tag>
      ),
    },
  ]

  return (
    <div>
      <Button
        type="dashed"
        size="small"
          style={{ height: 'auto', padding: '0 8px' }} // Adjust padding as needed
        onClick={() => setOpen(!open)}
        disabled={rowData.gasProjectProcessViewModel?.length === 0}
      >
        {rowData.gasProjectProcessViewModel?.length > 0 ? (
          <span
            style={{
              color:
                rowData.currentInspectionStatusEnum === 3 ||
                rowData.currentInspectionStatusEnum === 2
                  ? "red"
                  : "green",
                    display: 'inline-block',
        textAlign: 'center'
            }}
          >
            {rowData.engCurrentName}
            <br/>
            {rowData.currentInspectionStatusName}
          </span>
        ) : (
          "مشخص نشده"
        )}
      </Button>

      <Modal
        title={`تخصیص های مربوط به پرونده: ${rowData.fileNumber}`}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={900}
        zIndex={2000}
        centered
      >
        <Table
          columns={columns}
          dataSource={rowData.gasProjectProcessViewModel || []}
          rowKey="id"
          bordered
          size="middle"
          pagination={false}
          scroll={{ x: true }}
        />
      </Modal>
    </div>
  )
}
